import Vue from 'vue'
import Router from 'vue-router';

Vue.use(Router)

//获取原型对象上的push函数  解决路由重定向的问题
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


export const constantRouterMap = [
  {
    path: '/',
    hidden: true,
    component: ()=> import ("@/pages/logIn/logIn")
  },
  {
    path: '/404',
    hidden: true,
    component:()=>import("@/pages/404.vue")
  }
]

export default new Router({
  mode: 'history',
  routes: constantRouterMap
})
export const asyncRouterMap = []



// WEBPACK FOOTER //
// ./src/router/index.js